// extracted by mini-css-extract-plugin
export default {"useModal":"styles-module__useModal--Fbowm","card":"styles-module__card--veOvQ"};